import { createContext, useContext, useMemo, useRef, useState } from "react";
import { useAccountingViewModel } from "./useAccountingViewModel";

const AccountingContext = createContext();

export const AccountingProvider = ({ children }) => {
  const [selectedOrder, setSelectedOrder] = useState({});
  const [isOrderActivityDrawerOpen, setIsOrderActivityDrawerOpen] =
    useState(false);

  const { getOrderActivity } = useAccountingViewModel();
  const actionMenuRef = useRef();

  const openDrawer = () => setIsOrderActivityDrawerOpen(true);
  const closeDrawer = () => setIsOrderActivityDrawerOpen(false);

  const value = useMemo(
    () => ({
      isOrderActivityDrawerOpen,
      openDrawer,
      closeDrawer,
      actionMenuRef,
      selectedOrder,
      setSelectedOrder,
      getOrderActivity,
    }),
    [isOrderActivityDrawerOpen, actionMenuRef, selectedOrder]
  );

  return (
    <AccountingContext.Provider value={value}>
      {children}
    </AccountingContext.Provider>
  );
};

export const useAccountingContext = () => {
  const context = useContext(AccountingContext);
  if (!context) {
    throw new Error(
      "useAccountingContext must be used within a AccountingProvider"
    );
  }
  return context;
};
